import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static searchUsers(startAt = 0, numberToGet = 100, searchTerm = -1) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/search/searchusers/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm,
      {},
      "GET"
    );
  }

  static searchPosts(startAt = 0, numberToGet = 100, searchTerm = -1) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/search/searchposts/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm,
      {},
      "GET"
    );
  }

  static searchGroups(startAt = 0, numberToGet = 100, searchTerm = -1) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/search/searchgroups/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm,
      {},
      "GET"
    );
  }
}
